import * as actionTypes from "./actionTypes";
export const AssignDlgOpen = (member) => {
    return {
        type: actionTypes.ASSIGNDLG_OPEN,
        member
    };
};

export const AssignDlgClose = () => {
    return {
        type: actionTypes.ASSIGNDLG_CLOSE
    };
};

export const FilterDlgOpen = () => {
    return {
        type: actionTypes.FILTERDLG_OPEN
    };
};
export const FilterDlgClose = () => {
    return {
        type: actionTypes.FILTERDLG_CLOSE
    };
};

export const AccessDlgOpen = () => {
    return {
        type: actionTypes.ACCESSDLG_OPEN
    };
};
